module.exports = __webpack_public_path__ + "static/original-2-f3aeda383ae957bcc35b9aa325e6bfc4.png";